<!--
 * @Description: 
 * @Date: 2020-07-16 18:27:04
-->
<template>
  <div
    class="ebox"
    :id="uuid"
    :style="{
      ...echartStyle,
      maxHeight: echartType == 'bar' ? '' : '',
      height: `${height}px`
    }"
  ></div>
</template>

<script>
import echartsConfig from './config';
import { deepClone } from '@/tools/index';
import china from '@/assets/json/china.json';
import chinaMapOutline from '@/assets/json/chinaMapOutline.json';
export default {
  // inject: {
  //   items: {
  //     type: Object,
  //     default() {
  //       return {};
  //     }
  //   }
  // },
  props: {
    echartOption: {
      type: Object,
      default() {
        return {
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          series: [
            {
              type: 'bar',
              data: [18203, 23489, 29034, 104970, 131744, 630230]
            }
          ],
          series0data: null // 仅仅为series[0]中的data，需要扩展
        };
      }
    },
    echartType: {
      type: String,
      default: 'line'
    },
    echartStyle: {
      type: Object,
      default() {
        return {
          height: '400px'
        };
      }
    }
  },
  data() {
    return {
      uuid: this.$uuidv4(),
      height: 0
    };
  },
  watch: {
    echartOption: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.$nextTick(() => {
            this.init();
          });
        }
      }
    }
  },
  methods: {
    init() {
      try {
        const d = {
          1: 50,
          2: 28,
          3: 19,
          4: 14,
          5: 11,
          6: 8,
          7: 7,
          8: 6,
          9: 5,
          10: 5,
          11: 4,
          12: 4
        };
        const xAxisArr = this.echartOption.xAxis.data || [];
        const maxLength = xAxisArr.reduce((pre, cur) => {
          pre = Math.max(`${cur}`.length, pre);
          return pre;
        }, 0);
        const row = Math.ceil(maxLength / (d[xAxisArr.length] || 4));
        this.height = 450 + row * 19;
      } catch (err) {
        console.warn(err);
      }
      setTimeout(() => {
        let dom = document.getElementById(this.uuid);
        if (this.echartType === 'map') {
          this.$echarts.registerMap('china', china);
          this.$echarts.registerMap('chinaMapOutline', chinaMapOutline);
          //   map.features.reduce((pre, cur) => {
          //   pre[cur.properties.name] = cur.properties.cp;
          //   return pre;
          // }, {})
        }
        const propSeries = this.echartOption.series;
        const formatSeries = deepClone(
          echartsConfig[this.echartType].series || []
        );
        // 混合Series
        if (propSeries && propSeries.length) {
          propSeries.forEach((item, index) => {
            formatSeries[index] = {
              ...(formatSeries[index] && formatSeries[index]),
              ...item
            };
          });
        }
        // 合并其他属性 需要重构，递归方式
        const propOptions = this.echartOption || {};
        const formatOptions = deepClone(echartsConfig[this.echartType] || {});

        Object.entries(propOptions).forEach(item => {
          if (['color', 'backgroundColor'].includes(item[0])) {
            formatOptions[item[0]] = item[1];
          } else {
            formatOptions[item[0]] = {
              ...(formatOptions[item[0]] && formatOptions[item[0]]),
              ...item[1]
            };
          }
        });
        let options = {
          ...formatOptions,
          ...(formatSeries.length && { series: formatSeries })
        };
        if (this.echartOption.series0data) {
          if (Array.isArray(this.echartOption.series0data[0])) {
            this.echartOption.series0data.forEach((item, index) => {
              if (index == 0) {
                options.series[0].data = item;
                return;
              }
              options.series.push({
                ...options.series[0],
                data: item
              });
            });
          } else {
            options.series[0].data = this.echartOption.series0data;
          }
        }
        const maxLength = options.series[0].data.length;
        const cloneArr = [...options.series[0].data];
        const myChart = this.$echarts.init(dom, null, {
          renderer: maxLength > 200 ? '' : 'svg'
        });
        if (maxLength > 200) {
          const setData = (_myChart, startIndex) => {
            const endIndex = startIndex + 200;
            if (startIndex == 0) {
              options.series[0].data = cloneArr.slice(startIndex, endIndex);
              _myChart.setOption(options);
            } else {
              _myChart.appendData({
                seriesIndex: '0',
                data: cloneArr.slice(startIndex, endIndex)
              });
            }
            if (maxLength > endIndex) {
              setTimeout(
                () => {
                  setData(_myChart, endIndex);
                },
                startIndex == 0 ? 0 : 100
              );
            }
          };
          setData(myChart, 0);
        } else {
          myChart.setOption(options);
        }
      }, 500);
    }
  },
  mounted() {},
  created() {
    try {
      const { height } = this.echartStyle;
      this.height = parseInt(height);
    } catch (err) {
      console.error(err);
    }
  }
};
</script>

<style scoped lang="scss">
.ebox {
  display: flex;
  max-width: '920px';
  max-height: '450px';
  width: '100%';
  & + .ebox {
    margin-top: 80px;
  }
}
</style>
